<template>
  <label :class="classes" ref="label" @click="focus" @keydown.prevent.enter="$refs.label.click()">
    <input
      v-model="computedValue"
      @click.stop
      :name="name"
      type="radio"
      class="radio__field"
      :value="nativeValue"
      :disabled="$attrs.disabled"
    />
    <span :class="labelClasses">
      <slot></slot>
    </span>
  </label>
</template>

<script>
import CheckRadioMixin from "../../../utils/CheckBoxRadioMixin.js";

export default {
  name: "M4Radio",
  mixins: [CheckRadioMixin],
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return ["radio"];
    },
    labelClasses() {
      let classes = ["radio__label"];
      if (this.error) {
        classes.push("radio__label--error");
      }
      if (this.isDisabled) {
        classes.push("radio__label--disabled");
      }
      return classes;
    },
    isDisabled() {
      return this.$attrs.disabled !== undefined;
    }
  }
};
</script>
